import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';


import {DateRangeInput} from 'src/components/input';
import {COLUMNS, HEADERS} from 'src/modules/internal-notification/notification-list/constants';
import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';
import {SortField} from 'src/openapi/admin/models/SortField';

import {SortHeaderFilter} from '@pb/kit-component-filters';
import {Group} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';

import {
    notificationsListStateActions,
    notificationsListStateSelector,
} from '../../slices/notification-search-criteria.slice';

export const NotificationEndDateHeader = () => {
    const dispatch = useDispatch();
    const state = useSelector(notificationsListStateSelector);
    const [startDate, setStartDate] = useState(state.filters.startDate);
    const [endDate, setEndDate] = useState(state.filters.endDate);

    useEffect(() => {
        setStartDate(state.filters.startDate);
        setEndDate(state.filters.endDate);
    }, [state.filters]);

    const applyFilter = useCallback(() => {
        if (state.filters.endDate !== endDate) {
            const {endDate: _endDate, ...filters} = state.filters;

            dispatch(notificationsListStateActions.setFilters({
                ...filters,
                ...endDate ? {endDate} : {},
            }));
        }
    }, [endDate, state.filters, dispatch]);

    const sort = useCallback((direction: 'ASC' | 'DESC') => {
        dispatch(notificationsListStateActions.setSortCriteria(
            {field: SortField.END_DATE, direction: direction as SortDirections},
        ));
        applyFilter();
    }, [dispatch, applyFilter]);

    const clearFilter = useCallback(() => {
        const {endDate: _endDate, ...filters} = state.filters;
        setEndDate(undefined);
        dispatch(notificationsListStateActions.setFilters(filters));
    }, [state, setEndDate, dispatch]);

    const cancelFilter = useCallback(() => {
        setEndDate(state.filters.endDate);
    }, [state, setEndDate]);

    return (
        <SortHeaderFilter
            filterActive={!!endDate}
            sortable={true}
            caption={HEADERS[COLUMNS.END_DATE]}
            direction={state.sortCriteria.field === SortField.END_DATE
                ? state.sortCriteria.direction
                : undefined}
            defaultDirection={SortDirections.ASC}
            onSort={sort}
            onApply={applyFilter}
            onReset={clearFilter}
            onCancel={cancelFilter}>
            <Group direction="v" style={{width: 270}}>
                <Label htmlFor="notification-filter-end-date-picker">End Date</Label>
                <DateRangeInput
                    id="notification-filter-end-date-picker"
                    width={270}
                    label="Ends"
                    clearable={true}
                    selectRangeType="end"
                    startDate={startDate as string | undefined}
                    endDate={endDate as string | undefined}
                    onChange={setEndDate}
                />
            </Group>
        </SortHeaderFilter>
    );
};
